module.exports = __webpack_public_path__ + "img/ricelog_pinicon_041.3f91a3dd.png";